import { render, staticRenderFns } from "./MasterCampaignGeneral.vue?vue&type=template&id=d886d618&"
import script from "./MasterCampaignGeneral.vue?vue&type=script&lang=js&"
export * from "./MasterCampaignGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports